import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import styles from './footer.module.scss';
import { Link } from 'react-scroll';

const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div>
          <h2 className={styles.header}>Let us Build Something Strong</h2>
          <p className={styles.copy}>
            Open to meaningful products, technical leadership, and impactful collaborations.
          </p>
        </div>

        <div className={styles['social-networks']}>
          <a
            href="https://www.linkedin.com/in/cerejo/"
            target="_blank"
            rel="noreferrer"
            aria-label="Link to my linkedin profile"
          >
            <FontAwesomeIcon icon={icon({ name: 'linkedin', style: 'brands' })} color="#f4f2eb" size="2x" />
          </a>
        </div>
      </div>

      <Link className={styles['back-to-top']} to="home" spy={true} smooth={true} offset={0} duration={500}>
        Back to Top
      </Link>
    </footer>
  );
};

export default Footer;
